import { useSelector } from "react-redux";

import { DataTable } from "../../../components/DataTable";
import {
  setCollectionYardsVisitsDetailPagination,
  setCollectionYardsVisitsDetailScrollTop,
} from "../../../reducers/collectionYardsVisitsDetailReducer";
import {
  getCollectionYardsVisitsDetail,
  getCollectionYardsVisitsDetailScrollTop,
  getCollectionYardsVisitsDetailVisits,
  getIsCollectionYardsVisitsStatusLoading,
} from "../../../selectors/collectionYardsVisitsDetail";
import { useGetCollectionYardsVisitsDetailTableColumns } from "./useGetCollectionYardsVisitsDetailTableColumns";
import { useGetCollectionYardsVisitsDetailTableHandlers } from "./useGetCollectionYardsVisitsDetailTableHandlers";

import styles from "./CollectionYardsVisitsDetailTable.module.scss";

export const CollectionYardsVisitsDetailTable: React.FC = () => {
  const data = useSelector(getCollectionYardsVisitsDetailVisits);
  const columns = useGetCollectionYardsVisitsDetailTableColumns();
  const isLoading = useSelector(getIsCollectionYardsVisitsStatusLoading);
  const scrollTop = useSelector(getCollectionYardsVisitsDetailScrollTop);
  const collectionYardsState = useSelector(getCollectionYardsVisitsDetail);
  const { handleAdditionalRowClick } = useGetCollectionYardsVisitsDetailTableHandlers();

  return (
    <DataTable
      className={styles.container}
      dataRows={data}
      columns={columns}
      scrollTop={scrollTop}
      setScrollTop={setCollectionYardsVisitsDetailScrollTop}
      setPagination={setCollectionYardsVisitsDetailPagination}
      isLoading={isLoading}
      sliceState={collectionYardsState}
      handleAdditionalRowClick={handleAdditionalRowClick}
    />
  );
};
